export const chart = {
  async lineChartOption(params: string) {
    const option = {
      title: {
        text: "line chart",
      },
      tooltip: {},
      xAxis: {
        data: ["a", "b", "c", "d", "e", "f"],
      },
      yAxis: {},
      series: [
        {
          name: "销量",
          type: "bar",
          data: [5, 20, 36, 10, 10, 20],
        },
      ],
    };
    return option;
  },

  async polarChartOption(params: string) {
    const option = {
      title: {
        text: "某站点用户访问来源",
        subtext: "纯属虚构",
        left: "center",
      },
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "vertical",
        left: "left",
      },
      series: [
        {
          name: "访问来源",
          type: "pie",
          radius: "50%",
          data: [
            { value: 1048, name: "搜索引擎" },
            { value: 735, name: "直接访问" },
            { value: 580, name: "邮件营销" },
            { value: 484, name: "联盟广告" },
            { value: 300, name: "视频广告" },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
    return option;
  },

  async pieChartOption(params: string) {
    const option = {
      title: {
        text: "某站点用户访问来源",
        subtext: "纯属虚构",
        left: "center",
      },
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "vertical",
        left: "left",
      },
      series: [
        {
          name: "访问来源",
          type: "pie",
          radius: "50%",
          data: [
            { value: 1048, name: "搜索引擎" },
            { value: 735, name: "直接访问" },
            { value: 580, name: "邮件营销" },
            { value: 484, name: "联盟广告" },
            { value: 300, name: "视频广告" },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
    return option;
  },

  async echartsOptions(params: string) {
    const polarData = [];
    for (let i = 0; i <= 360; i++) {
      const t = (i / 180) * Math.PI;
      const r = Math.sin(2 * t) * Math.cos(2 * t);
      polarData.push([r, i]);
    }
    const echartOptions = {
      data: {
        lineChartOption: {
          title: {
            text: "line chart",
          },
          tooltip: {},
          xAxis: {
            data: ["a", "b", "c", "d", "e", "f"],
          },
          yAxis: {},
          series: [
            {
              name: "销量",
              type: "bar",
              data: [5, 20, 36, 10, 10, 20],
            },
          ],
        },
        polarChartOption: {
          title: {
            text: "polar chart",
            subtext: "纯属虚构",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "50%",
              data: [
                { value: 1048, name: "搜索引擎" },
                { value: 735, name: "直接访问" },
                { value: 580, name: "邮件营销" },
                { value: 484, name: "联盟广告" },
                { value: 300, name: "视频广告" },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        },
        pieChartOption: {
          title: {
            text: "pie chart",
            subtext: "纯属虚构",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "50%",
              data: [
                { value: 1048, name: "搜索引擎" },
                { value: 735, name: "直接访问" },
                { value: 580, name: "邮件营销" },
                { value: 484, name: "联盟广告" },
                { value: 300, name: "视频广告" },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        },
      },
    };
    return echartOptions;
  },

  async echartsOptions2(params: string) {
    const polarData = [];
    for (let i = 0; i <= 360; i++) {
      const t = (i / 180) * Math.PI;
      const r = Math.sin(2 * t) * Math.cos(2 * t);
      polarData.push([r, i]);
    }
    const echartOptions2 = {
      data: [
        {
          title: {
            text: "line chart",
          },
          tooltip: {},
          xAxis: {
            data: ["a", "b", "c", "d", "e", "f"],
          },
          yAxis: {},
          series: [
            {
              name: "销量",
              type: "bar",
              data: [5, 20, 36, 10, 10, 20],
            },
          ],
        },
        {
          title: {
            text: "极坐标双数值轴",
          },
          legend: {
            data: ["line"],
          },
          polar: {
            center: ["50%", "54%"],
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
            },
          },
          angleAxis: {
            type: "value",
            startAngle: 0,
          },
          radiusAxis: {
            min: 0,
          },
          series: [
            {
              coordinateSystem: "polar",
              name: "line",
              type: "line",
              showSymbol: false,
              data: polarData,
            },
          ],
          animationDuration: 2000,
        },
        {
          angleAxis: {},
          radiusAxis: {
            type: "category",
            data: ["周一", "周二", "周三", "周四"],
            z: 10,
          },
          polar: {},
          series: [
            {
              type: "bar",
              data: [1, 2, 3, 4],
              coordinateSystem: "polar",
              name: "A",
              stack: "a",
              emphasis: {
                focus: "series",
              },
            },
            {
              type: "bar",
              data: [2, 4, 6, 8],
              coordinateSystem: "polar",
              name: "B",
              stack: "a",
              emphasis: {
                focus: "series",
              },
            },
            {
              type: "bar",
              data: [1, 2, 3, 4],
              coordinateSystem: "polar",
              name: "C",
              stack: "a",
              emphasis: {
                focus: "series",
              },
            },
          ],
          legend: {
            show: true,
            data: ["A", "B", "C"],
          },
        },
      ],
    };

    return echartOptions2;
  },
};
